module.exports = __webpack_public_path__ + "img/close-icon.a1ea3577.svg";